import FetchBase from '../Api/FetchBase'
import { observable, action, computed } from 'mobx'
import {
  API_ENDPOINTS,
  PAGE_LIMIT_FOR_TASKLIST,
  DASHBOARD_RECORD_LIMIT,
  API_CONSTANTS,
  DEFAULT_PER_PAGE_RECORD,
  DEFAULT_PAGE_START,
  ERROR_CODE,
} from '../Utils/constants'
import { generateFormData, zeroWrapper } from '../Utils/helpers'
import { getUtcUnixDate } from '../Utils/rules'

export default class TasksStore extends FetchBase {
  @observable genericTaskLoader = false
  @observable taskGroupLoader = false
  @observable taskLoader = undefined
  @observable addTaskLoader = false
  @observable specificTaskLoader = false
  @observable editTaskLoader = false

  @observable ordering = undefined
  @observable orderingBy = undefined
  @observable bulkTaskUpdateLoader = false
  @observable allDropdownTaskGroupsList = []
  @observable allDropdownTaskGroupslistFromFolder = []
  @observable allDropdownTaskAssignedRoles = []
  @observable allDropdownTaskAssignedUsers = []
  @observable allTaskGroups = []
  @observable taskGroups = []
  @observable isUserAssignedInTaskGroups = false
  @observable taskList = []
  @observable taskListforDropdown = []
  @observable cfSelectedDateChoice = undefined

  @observable task = {}
  @observable isUserAssignedInTask = false
  @observable taskTemplates = []
  @observable taskTemplatesForDropdown = []

  @observable taskTypes = []
  @observable taskSubTypes = []
  @observable allTaskStatus = []

  @observable openedTaskGroupIdGlobal = undefined

  @observable assignTaskLoader = false
  @observable changeTaskStatusLoader = false

  @observable projectDashboardAllTasksLoader = false
  @observable projectDashboardAllTasks = {}
  @observable projectDashboardStatusId =
    API_CONSTANTS.PROJECT_DASHBOARD_IN_PROGRESS
  @observable dropdownDashboardSpaceId = undefined

  @observable dashboardAllTasksPageNo = DEFAULT_PAGE_START
  @observable dashboardAllTasksPageSize = DEFAULT_PER_PAGE_RECORD
  @observable dashboardAllTasksLoader = false
  @observable dashboardAllTasksTotal = 0
  @observable dashboardAllTasks = []
  @observable dashboardAllTasksSearchText = ''
  @observable dashboardAllTaskPageFilters = ''
  @observable isCommingFromWieght = false
  @observable spaceShortDetailsForTask = {}

  @observable taskSearchText = undefined
  @observable taskGroupForSpaceLoader = false

  @observable addTaskGroupsToSpaceLoader = false
  @observable deleteTaskGroupsToSpaceLoader = false

  @observable importTasks = []
  @observable importTaskFailures = []
  @observable importTasksLoader = false

  @observable importEquipments = []
  @observable importEquipmentsFailures = []
  @observable importEquipmentsLoader = false

  @action.bound
  setOrdering = (value = undefined) => {
    this.ordering = value
  }

  @action.bound
  setOrderingBy = (value = undefined) => {
    this.orderingBy = value
  }

  @action.bound
  setTaskSearchText = (value = undefined) => {
    this.taskSearchText = value
  }

  @action.bound
  setDashboardAllTasksSearchText = (value = '') => {
    this.dashboardAllTasksSearchText = value
  }

  @action.bound
  setDashboardAllTasksPageNo = (page = DEFAULT_PAGE_START) => {
    this.dashboardAllTasksPageNo = page
  }

  @action.bound
  setDashboardAllTasksPageSize = (size = DEFAULT_PER_PAGE_RECORD) => {
    this.dashboardAllTasksPageSize = size
  }

  @action.bound
  setProjectDashboardStatusId = (
    value = API_CONSTANTS.PROJECT_DASHBOARD_IN_PROGRESS
  ) => {
    this.projectDashboardStatusId = value
  }

  @action.bound
  setProjectDashboardSpaceId = (value = undefined) => {
    this.dropdownDashboardSpaceId = value
  }

  @action.bound
  resetCacheFields = () => {
    this.openedTaskGroupIdGlobal = undefined
  }

  @action.bound
  setEditTaskLoader = (value = false) => {
    this.editTaskLoader = value
  }

  @action.bound
  setOpenedTaskGroupIdGlobal = (value = undefined) => {
    this.openedTaskGroupIdGlobal = value
  }

  @action.bound
  setGenericTaskLoader = (value = false) => {
    this.genericTaskLoader = value
  }

  @action.bound
  setSelectedDateChoice = (value = undefined) => {
    this.cfSelectedDateChoice = value
  }

  @action.bound
  getAllDropdownTaskGroupList = async (projectId = undefined, signal) => {
    if (!projectId) {
      return [false, undefined]
    }
    try {
      let response = await this.post(
        API_ENDPOINTS.GET_DROPDOWN_TASK_GROUPS_LIST,
        {
          projectId,
        },
        signal
      )
      if (response.status) {
        this.allDropdownTaskGroupsList = response.data.taskGroups
        return [true, response.data.taskGroups]
      }
      this.allDropdownTaskGroupsList = []
      return [false, undefined]
    } catch (err) {
      this.allDropdownTaskGroupsList = []
      return [false, undefined]
    }
  }

  @action.bound
  allTaskGroupFromFolderDropdown = (list = []) => {
    let arrayOfGroup = []
    for (let i = 0; i < list.length; i++) {
      const { taskGroups = [] } = list[i]
      for (let i = 0; i < taskGroups.length; i++) {
        arrayOfGroup.push(taskGroups[i])
      }
    }
    this.allDropdownTaskGroupslistFromFolder = arrayOfGroup
  }

  @action.bound
  getAllDropdownTaskAssigned = async (projectId = undefined, signal) => {
    if (!projectId) {
      return [false, undefined]
    }
    try {
      let response = await this.post(
        API_ENDPOINTS.GET_DROPDOWN_TASK_ASSIGNED,
        {
          projectId,
        },
        signal
      )
      if (response.status) {
        this.allDropdownTaskAssignedRoles = response.data.taskAssignedRoles
        this.allDropdownTaskAssignedUsers = response.data.taskAssignedUsers
        return [true, response.data]
      }
      this.allDropdownTaskAssignedRoles = []
      this.allDropdownTaskAssignedUsers = []
      return [false, undefined]
    } catch (err) {
      this.allDropdownTaskAssignedRoles = []
      this.allDropdownTaskAssignedUsers = []
      return [false, undefined]
    }
  }

  @action.bound
  getAllTaskGroups = async (spaceId = undefined) => {
    if (!spaceId) {
      return [false, undefined]
    }
    try {
      let response = await this.get(API_ENDPOINTS.GET_TASK_GROUPS_LIST, {
        //spaceId,
      })
      if (response.status) {
        this.allTaskGroups = response.data
        return [true, response.data]
      }
      this.allTaskGroups = []
      return [false, undefined]
    } catch (err) {
      this.allTaskGroups = []
      return [false, undefined]
    }
  }

  @action.bound
  getFiltersForTaskgroupsBySpace = () => {
    let options = {}
    this.taskSearchText && (options['search'] = this.taskSearchText)
    return options
  }

  @action.bound
  getTaskGroups = async (spaceId = undefined, signal) => {
    if (!spaceId) {
      return [false, undefined]
    }
    try {
      this.taskGroupForSpaceLoader = true
      let options = this.getFiltersForTaskgroupsBySpace()
      let response = await this.get(
        API_ENDPOINTS.GET_TASK_GROUPS,
        {
          spaceId,
          ...options,
        },
        signal
      )
      if (response.status) {
        this.taskGroups = response?.data?.taskGroupCounts || []
        this.spaceShortDetailsForTask = response?.data?.spaceDetails || {}
        this.isUserAssignedInTaskGroups = response?.isUserAssigned
        return [true, response?.data?.taskGroupCounts]
      }
    } catch (err) {
      this.taskGroups = []
      this.isUserAssignedInTaskGroups = false
      return [false, undefined]
    } finally {
      this.taskGroupForSpaceLoader = false
    }
  }

  @action.bound
  __normalizeObject = ({ id, count = undefined, name }) => {
    return {
      taskGroupId: id,
      taskCount: Number(count || 0),
      taskGroupName: name || '-',
    }
  }

  @action.bound
  normalizeTaskGroup = () => {
    if (this.taskGroups) {
      this.taskGroups = (this.taskGroups || []).map((task) => {
        const { taskGroupId, taskCount, inTaskGroup = {} } = task
        const { id = undefined, name = '' } = inTaskGroup || {}
        return this.__normalizeObject({
          id: taskGroupId,
          count: taskCount,
          name,
        })
      })
    }
  }

  @action.bound
  reorderTaskGroupsLocally = (newTaskGroups = this.taskGroups || []) => {
    this.taskGroups = [...newTaskGroups]
  }

  @action.bound
  reorderTaskGroups = async ({ spaceId, newTaskGroupsOrder = [] } = {}) => {
    try {
      let response = await this.post(API_ENDPOINTS.REORDER_TASK_GROUPS, {
        spaceId,
        newTaskGroupIdsInOrder: newTaskGroupsOrder,
      })
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  addTaskGroupToSpace = async (spaceId, taskGroupIds) => {
    try {
      this.addTaskGroupsToSpaceLoader = true
      let response = await this.post(API_ENDPOINTS.ADD_TASK_GROUPS_IN_SPACE, {
        spaceId,
        taskGroupIdArr: taskGroupIds,
      })
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.addTaskGroupsToSpaceLoader = false
    }
  }

  @action.bound
  deleteTaskGroupLocally = (id) => {
    this.taskGroups = (this.taskGroups || []).filter((taskGroup) => {
      return id !== taskGroup?.taskGroupId
    })
  }

  @action.bound
  deleteTaskGroupToSpace = async (spaceId, taskGroupId) => {
    try {
      this.deleteTaskGroupsToSpaceLoader = true
      let response = await this.post(API_ENDPOINTS.DELETE_TASK_GROUP_IN_SPACE, {
        spaceId,
        taskGroupId: taskGroupId,
      })
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.deleteTaskGroupsToSpaceLoader = false
    }
  }

  @computed
  get totalTaskCountInSpace() {
    let count = (this.taskGroups || []).reduce((acc, group) => {
      return acc + (group?.taskCount || 0)
    }, 0)
    return count
  }

  @action.bound
  addTaskGroupsLocally = (taskGroups = []) => {
    let normalizeTaskGroups = new Set(taskGroups)
    let getTaskObjects = (
      this.allDropdownTaskGroupslistFromFolder || []
    ).filter(({ id, name }) => {
      return normalizeTaskGroups.has(id)
    })
    this.taskGroups = [
      ...this.taskGroups,
      ...getTaskObjects.map((taskGroup) => {
        const { id, name } = taskGroup
        return this.__normalizeObject({
          id,
          name,
          count: 0,
        })
      }),
    ]
  }

  @action.bound
  setCountOfTaskGroup = (id, options = {}) => {
    const { taskGroupData = {} } = options
    const operationValue = (target) => {
      const { operation = '+', value = 1 } = options

      switch (operation) {
        case '+':
          return target + value
        case '-':
          return Math.max(0, target - value)
        default:
          return target
      }
    }
    let findedGroup = (this.taskGroups || []).find(
      (taskGroup) => taskGroup.taskGroupId === id
    )
    if (findedGroup) {
      this.taskGroups = (this.taskGroups || []).map((taskGroup) => {
        if (taskGroup.taskGroupId === id) {
          const { taskCount } = taskGroup
          return {
            ...taskGroup,
            taskCount: operationValue(taskCount),
          }
        } else {
          return taskGroup
        }
      })
    } else {
      this.taskGroups = [
        ...(this.taskGroups || []),
        this.__normalizeObject({
          id,
          name: taskGroupData?.name,
          count: 1,
        }),
      ]
    }
  }

  @action.bound
  addNewTaskLocally = async (task) => {
    if (task.id) this.taskList = [...this.taskList, task]
  }

  @action.bound
  setTaskLocallyViaTemplate = (task) => {
    if (this.openedTaskGroupIdGlobal === task?.taskGroupId) {
      this.addNewTaskLocally(task)
    }
  }

  @action.bound
  addNewTask = async (values = {}) => {
    try {
      this.addTaskLoader = true

      const {
        spaceId,
        taskGroupId,
        taskname,
        hours,
        startDate,
        endDate,
        assign = [],
        isAssignedToRole = false,
        picture = false,
        taskType,
        taskSubType,
        taskDescription,
      } = values

      let assignOptions = {}
      if (isAssignedToRole) {
        assignOptions['assignedRoleId'] = assign
      } else {
        assignOptions['assignUsers'] = assign
      }

      let response = await this.post(API_ENDPOINTS.ADD_TASK, {
        spaceId,
        taskGroupId,
        name: taskname,
        totalHours: hours,
        taskStatusId: this.__getStatus(),
        startDate,
        endDate,
        isAssignedToRole,
        imageRequired: picture,
        taskTypeId: taskType,
        taskSubTypeId: taskSubType,
        taskDescription: taskDescription || undefined,
        ...assignOptions,
      })
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.addTaskLoader = false
    }
  }

  @action.bound
  deleteTaskLocally = (id) => {
    if (id) {
      this.taskList = (this.taskList || []).filter((task) => {
        return task.id !== id
      })
    }
  }

  deleteTask = async (id) => {
    try {
      let response = await this.post(API_ENDPOINTS.DELETE_TASK, {
        id,
      })
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  updateTaskLocally = (values) => {
    this.task = {
      ...(this.task || {}),
      ...values,
    }
  }

  @action.bound
  updateTaskInTaskList = (id, values) => {
    this.taskList = (this.taskList || []).map((task) => {
      if (task.id === id) {
        return values
      } else {
        return task
      }
    })
  }

  updateTask = async (values) => {
    try {
      const {
        id,
        taskname,
        hours,
        startDate,
        endDate,
        taskType,
        taskSubType,
        picture = false,
        totalHours,
        taskDescription,
        taskGroupId,
      } = values

      let response = await this.post(API_ENDPOINTS.UPDATE_TASK, {
        id,
        name: taskname,
        startDate: startDate || null,
        endDate: endDate || null,
        taskGroupId: taskGroupId || null,
        taskTypeId: taskType || null,
        taskSubTypeId: taskSubType || null,
        imageRequired: picture,
        taskDescription: taskDescription || undefined,
        totalHours: zeroWrapper(totalHours) ? zeroWrapper(totalHours) : null,
      })
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  reorderDataSourceUpdate = async (newOrder = []) => {
    if (newOrder.length) this.taskList = newOrder
  }

  @action.bound
  reorderSubmit = async ({ spaceId, taskGroupId, newOrder }) => {
    try {
      let response = await this.post(API_ENDPOINTS.REORDER_TASK, {
        spaceId,
        taskGroupId,
        newIdsInOrder: newOrder,
      })
      return response.status || false
    } catch (err) {
      return false
    }
  }

  @action.bound
  getTasksExport = async (
    spaceId = undefined,
    { exportFileType = 'csv' } = {}
  ) => {
    try {
      let response = await this.get(API_ENDPOINTS.EXPORT_TASK, {
        spaceId,
        exportFileType,
        pageLimit: 0,
      })
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  getFiltersForAllTasks = () => {
    let options = {}
    this.taskSearchText && (options['search'] = this.taskSearchText)

    return options
  }

  @action.bound
  getAllTasks = async (spaceId = undefined, options = {}) => {
    try {
      const { taskGroupId = undefined } = options
      this.taskLoader = taskGroupId

      options['pageLimit'] = PAGE_LIMIT_FOR_TASKLIST

      let extra = this.getFiltersForAllTasks()

      let response = await this.get(API_ENDPOINTS.GET_TASKS, {
        spaceId,
        ...options,
        ...extra,
      })
      if (response.status) {
        this.taskList = response.data.tasks || []
        return [true, response.data.tasks || []]
      }
      this.taskList = []
      return [false, undefined]
    } catch (err) {
      this.taskList = []
      return [false, undefined]
    } finally {
      this.taskLoader = undefined
    }
  }

  @action.bound
  getTasksFromMultipleSpaces = async (spaceIds = []) => {
    try {
      let response = await this.post(
        API_ENDPOINTS.GET_TASK_FOR_MULTIPLE_SPACE,
        {
          spaceIds,
        }
      )
      if (response.status) {
        this.taskListforDropdown = response.data.tasks
        return response.data.tasks || []
      }
      this.taskListforDropdown = []
      return [false, undefined]
    } catch (err) {
      this.taskListforDropdown = []
      return [false, undefined]
    } finally {
      this.taskLoader = undefined
    }
  }

  @action.bound
  getSpecificLastLocally = (taskList, id) => {
    return (taskList || []).find((task) => task.id === id)
  }

  @action.bound
  getSpecificTask = async (id, options = {}, signal) => {
    try {
      let notaload = !options?.notaload
      this.specificTaskLoader = notaload && true
      delete options?.notaload
      let response = await this.get(
        API_ENDPOINTS.GET_TASK_BY_ID,
        {
          id,
          ...options,
        },
        signal
      )
      if (response.status) {
        this.task = response.data
        this.isUserAssignedInTask = response?.isUserAssigned

        return [response.status, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.specificTaskLoader = false
    }
  }

  @action.bound
  getAllTaskTemplates = async (networkOnly = true) => {
    if (!networkOnly) {
      if (this.taskTemplates.length) {
        return [true, this.taskTemplates]
      }
    }
    try {
      let response = await this.get(
        API_ENDPOINTS.GET_ALL_TASK_TEMPLATES_DROPDOWN,
        {
          // spaceId,
          pageLimit: 0,
        }
      )
      if (response.status) {
        this.taskTemplates = response.data.taskTemplates
        return [response.status, response.data.taskTemplates]
      }
      return [false, undefined]
    } catch (err) {
      this.taskTemplates = []
      return [false, undefined]
    } finally {
      this.restructureForDropdown(this.taskTemplates)
    }
  }

  @action.bound
  restructureForDropdown = (taskTemplates = []) => {
    this.taskTemplatesForDropdown = (taskTemplates || []).map(
      (taskTemplate) => {
        return {
          id: taskTemplate.id,
          name: taskTemplate.name,
        }
      }
    )
  }

  @action.bound
  getDetailsAboutTemplate = (templateId) => {
    return (this.taskTemplates || []).find(
      (template) => template.id === templateId
    )
  }

  @action.bound
  getTaskTypes = async (taskGroupId) => {
    try {
      let response = await this.get(API_ENDPOINTS.GET_TASK_TYPES, {
        taskGroupId,
      })
      if (response.status) {
        this.taskTypes = response.data
        return [response.status, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  getTaskSubTypes = async (taskTypeId) => {
    try {
      let response = await this.get(API_ENDPOINTS.GET_TASK_SUB_TYPES, {
        taskTypeId,
      })
      if (response.status) {
        this.taskSubTypes = response.data
        return [response.status, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  importTasksFromFile = async (values) => {
    try {
      this.importTasksLoader = true
      let formDataValues = generateFormData(values)
      let response = await this.postWithFormData(
        API_ENDPOINTS.IMPORT_TASKS_FROM_FILE,
        formDataValues
      )
      if (response.status) {
        this.importTasks = response.data || []
        this.importTaskFailures =
          {
            headerMessage: response?.message || '',
            failedErrors: response.data?.failures || [],
            fileUpload: response.status,
            isError: true,
          } || []
        return [true, response.data]
      } else {
        return [false, undefined]
      }
    } catch (err) {
      if (err?.error?.statusCode === ERROR_CODE?.MENUAL_CODE) {
        this.importTaskFailures =
          {
            headerMessage: err?.message,
            failedErrors: null,
            fileUpload: false,
            isError: true,
          } || []
        return [false, undefined]
      } else {
        this.importTaskFailures =
          {
            headerMessage: err?.message,
            failedErrors: err?.error,
            fileUpload: false,
            isError: true,
          } || []
        return [false, undefined]
      }
    } finally {
      this.importTasksLoader = false
    }
  }

  @action.bound
  importEquipmentFromFile = async (values) => {
    try {
      this.importEquipmentsLoader = true
      let formDataValues = generateFormData(values)
      let response = await this.postWithFormData(
        API_ENDPOINTS.IMPORT_EQUIPMENT_FROM_FILE,
        formDataValues
      )
      if (response.status) {
        this.importEquipments = response.data || []
        this.importEquipmentsFailures =
          {
            headerMessage: response?.message || '',
            failedErrors: response.data?.failures || [],
            fileUpload: response.status,
            isError: true,
          } || []
        return [true, response.data]
      } else {
        return [false, undefined]
      }
    } catch (err) {
      if (err?.error?.statusCode === ERROR_CODE?.MENUAL_CODE) {
        this.importEquipmentsFailures =
          {
            headerMessage: err?.message,
            failedErrors: null,
            fileUpload: false,
            isError: true,
          } || []
        return [false, undefined]
      } else {
        this.importEquipmentsFailures =
          {
            headerMessage: err?.message,
            failedErrors: err?.error,
            fileUpload: false,
            isError: true,
          } || []
        return [false, undefined]
      }
    } finally {
      this.importEquipmentsLoader = false
    }
  }

  @action.bound
  importTaskFromFileReset = async () => {
    this.importTasks = []
    this.importEquipments = []
    this.importTaskFailures = []
    this.importEquipmentsFailures = []
  }

  @action.bound
  resetSubTypes = () => {
    this.taskSubTypes = []
  }

  @action.bound
  resetTaskStore = () => {
    this.taskSubTypes = []
    this.taskTypes = []
    this.task = {}
  }

  @action.bound
  assignTask = async (
    id,
    {
      isAssignedToRole = false,
      assignedRoleId = undefined,
      isAssignedToProjectRole = false,
      assignedProjectRoleId = undefined,
      assignUsers = [],
    }
  ) => {
    try {
      this.assignTaskLoader = id
      let response = await this.post(API_ENDPOINTS.ASSIGN_TASK, {
        id,
        isAssignedToRole,
        assignedRoleId,
        assignUsers,
        isAssignedToProjectRole,
        assignedProjectRoleId,
      })
      return [true, response.data]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.assignTaskLoader = undefined
    }
  }

  __getStatus = () => {
    let isStart = (this.allTaskStatus || []).find((status) => status.isStart)
    let isDefault = (this.allTaskStatus || []).find(
      (status) => status.isDefault
    )
    return (isStart || isDefault)?.id || 1
  }

  @action.bound
  updateStatusLocally = (taskStatusId) => {
    this.task = { ...this.task, taskStatusId }
  }

  @action.bound
  changeTaskStatus = async (id, values = {}) => {
    try {
      this.changeTaskStatusLoader = true
      let response = await this.post(API_ENDPOINTS.TASK_STATUS_CHANGE, {
        id,
        ...values,
      })
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.changeTaskStatusLoader = false
    }
  }

  @action.bound
  changeTaskStatusFromMain = async (id, values = {}) => {
    try {
      this.changeTaskStatusLoader = true
      let response = await this.post(API_ENDPOINTS.TASK_STATUS_CHANGE, {
        id,
        taskStatusId: values,
      })
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.changeTaskStatusLoader = false
    }
  }

  @action.bound
  getAllTaskStatus = async (signal) => {
    try {
      let response = await this.get(
        API_ENDPOINTS.GET_ALL_TASK_STATUSES,
        {},
        signal
      )
      if (response.status) {
        this.allTaskStatus = response.data
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  addTaskAttachmentsLocally = (image) => {
    if (this.task?.taskAttachments?.length) {
      this.task.taskAttachments.push(image)
    } else {
      this.task = { ...this.task, taskAttachments: [image] }
    }
  }

  @action.bound
  uploadTaskAttachments = async (values) => {
    try {
      let response = await this.postWithFormData(
        API_ENDPOINTS.ADD_TASK_ATTACHMENTS,
        generateFormData(values)
      )
      if (response.status) {
        return [true, response.data?.[0]]
      }
    } catch (err) {
      return [false, undefined]
    } finally {
    }
  }

  @action.bound
  deleteAttachmentLocally = (imageId) => {
    if (this.task?.taskAttachments?.length) {
      this.task.taskAttachments = (this.task.taskAttachments || []).filter(
        (image) => {
          return imageId !== image.id
        }
      )
    }
  }

  @action.bound
  deleteTaskAttachment = async (imageId) => {
    try {
      let response = await this.post(API_ENDPOINTS.DELETE_ATTACHMENTS, {
        id: imageId,
      })
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  getProjectDashboardAllTasks = async (
    projectId,
    taskStatusIdValue,
    spaceValueId
  ) => {
    try {
      this.projectDashboardAllTasksLoader = true
      let taskStatusId = [taskStatusIdValue]
      let spaceId = spaceValueId && [spaceValueId]
      let response = await this.post(API_ENDPOINTS.PROJECT_DASHBOARD_ALL_TAKS, {
        projectId,
        taskStatusId,
        spaceId,
        pageLimit: DASHBOARD_RECORD_LIMIT,
      })
      if (response.status) {
        this.projectDashboardAllTasks = response.data
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.projectDashboardAllTasksLoader = false
    }
  }

  @action.bound
  setFiltersForAllTasksPage = (values = {}) => {
    this.dashboardAllTaskPageFilters = values || {}
  }

  setStatusForAllTaskPageFromWieght = (value, isFromWieght = false) => {
    this.projectDashboardStatusId = value
    this.isCommingFromWieght = isFromWieght
  }

  @action.bound
  setStatusForAllTaskPage = (value, isFromWieght) => {
    this.projectDashboardStatusId = value
    this.isCommingFromWieght = isFromWieght
  }

  @action.bound
  generateFiltersForAllTasksPage = () => {
    let temp = {}
    const {
      taskStatusId = undefined,
      taskGroupId = undefined,
      assignedUserId = undefined,
      assignedRoleId = undefined,
      spaceId = undefined,
    } = this.dashboardAllTaskPageFilters || {}
    this.dashboardAllTasksSearchText &&
      (temp['search'] = this.dashboardAllTasksSearchText)

    let keys = Object.keys(this.dashboardAllTaskPageFilters || {})
    for (let filter of keys) {
      if (this.dashboardAllTaskPageFilters[filter] !== undefined) {
        temp[filter] = this.dashboardAllTaskPageFilters[filter]
      }
    }
    temp['taskStatusId'] = this.isCommingFromWieght
      ? [this.projectDashboardStatusId]
      : taskStatusId
      ? [taskStatusId]
      : []
    // temp['taskStatusId'] = taskStatusId
    //   ? [taskStatusId]
    //   : this.projectDashboardStatusId
    //   ? [this.projectDashboardStatusId]
    //   : []
    taskGroupId && (temp['taskGroupId'] = [taskGroupId])
    assignedRoleId && (temp['assignedRoleId'] = [assignedRoleId])
    assignedUserId && (temp['assignedUserId'] = [assignedUserId])
    spaceId && (temp['spaceId'] = [spaceId])

    if (this.cfSelectedDateChoice) {
      let dateFilter = getUtcUnixDate(this.cfSelectedDateChoice, {
        start: temp['startDate'],
        end: temp['endDate'],
      })
      temp['completedStartDate'] = dateFilter.start
      temp['completedEndDate'] = dateFilter.end
    } else {
      delete temp['startDate']
      delete temp['endDate']
    }

    delete temp['choice']
    delete temp['startDate']
    delete temp['endDate']

    if (this.ordering) {
      temp['ordering'] = this.ordering
      temp['orderBy'] = this.orderingBy
    }
    return temp
  }

  @action.bound
  getAllTasksForTaskPage = async (projectId, signal) => {
    try {
      this.dashboardAllTasksLoader = true
      let options = this.generateFiltersForAllTasksPage()
      let response = await this.post(
        API_ENDPOINTS.PROJECT_DASHBOARD_ALL_TAKS,
        {
          projectId,
          pageNo: Math.max(this.dashboardAllTasksPageNo - 1, 0),
          pageLimit: this.dashboardAllTasksPageSize,
          ...options,
        },
        signal
      )

      if (response.status) {
        this.dashboardAllTasksTotal = response.data?.total || 0
        this.dashboardAllTasks = response.data?.projectAllTasks || []
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.dashboardAllTasksLoader = false
    }
  }

  @action.bound
  AllTasksForTaskPageExportData = async (
    { exportFileType = 'csv' } = {},
    projectI = undefined
  ) => {
    try {
      let filters = this.generateFiltersForAllTasksPage()
      let options = { ...filters }
      options['exportFileType'] = exportFileType
      options['projectId'] = projectI
      let response = await this.post(
        API_ENDPOINTS.PROJECT_DASHBOARD_ALL_TAKS_EXPORT,
        options
      )
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  bulkTaskUpdate = async (bulkValues = {}) => {
    const convertInNumbers = (ids) => {
      return (ids || []).map(Number).filter((value) => {
        let num = Number(value)
        return num || num === 0
      })
    }

    try {
      this.bulkTaskUpdateLoader = true
      let { ids, values } = bulkValues
      const {
        isAssignedToRole = false,
        isAssignedToProjectRole = false,
        assign = [],
      } = values || {}
      delete values.isAssignedToRole
      delete values.assign

      let zeroWrapperTotalHours = zeroWrapper(values['totalHours'])
      zeroWrapperTotalHours && (values['totalHours'] = zeroWrapperTotalHours)

      let assignToInternal = {}

      if (isAssignedToRole) {
        if (assign) {
          assignToInternal['isAssignedToRole'] = true
          assignToInternal['assignedRoleId'] = assign
        }
      } else if (isAssignedToProjectRole) {
        assignToInternal['isAssignedToRole'] = false
        assignToInternal['isAssignedToProjectRole'] = true
        assignToInternal['assignedProjectRoleId'] = assign
      } else {
        if (assign && assign?.length) {
          assignToInternal['isAssignedToRole'] = false
          assignToInternal['assignUsers'] = convertInNumbers(assign)
        }
      }

      const { start, end } = getUtcUnixDate('custom', {
        start: values?.startDate,
        end: values?.endDate,
      })

      values['startDate'] = start
      values['endDate'] = end
      0 < Object.keys(assignToInternal).length &&
        (values = { ...values, ...assignToInternal })
      let response = await this.post(API_ENDPOINTS.BULK_TASK_UPDATE, {
        taskIds: convertInNumbers(ids),
        taskData: { ...values },
      })
      if (response.status) {
        return [true, response.data]
      } else {
        return [false, undefined]
      }
    } catch (err) {
      return [false, undefined]
    } finally {
      this.bulkTaskUpdateLoader = false
    }
  }

  @action.bound
  deleteBulkTask = async (bulkValues = {}) => {
    const convertInNumbers = (ids) => {
      return (ids || []).map(Number).filter((value) => {
        let num = Number(value)
        return num || num === 0
      })
    }
    try {
      const { ids = [] } = bulkValues
      let response = await this.post(API_ENDPOINTS.BULK_TASK_DELETE, {
        taskIds: convertInNumbers(ids),
      })
      if (response.status) {
        return [true, response.data]
      } else {
        return [false, undefined]
      }
    } catch (err) {
      return [false, undefined]
    }
  }

  /** global task groups add starts here */
  @action.bound
  addAllTaskGroupLocally = async (values = []) => {
    if (Array.isArray(values)) {
      this.allTaskGroups = [...this.allTaskGroups, ...values]
    } else {
      this.allTaskGroups = [...this.allTaskGroups, values]
    }
  }

  @action.bound
  addNewAllTaskGroups = async (values = []) => {
    try {
      this.taskGroupLoader = true
      const firstRecord = values[0]

      let response = await this.post(API_ENDPOINTS.ADD_TASK_GROUPS, {
        name: firstRecord,
      })
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.taskGroupLoader = false
    }
  }

  @action.bound
  updateAllTaskGroupLocally = (id, value = {}) => {
    this.allTaskGroups = (this.allTaskGroups || []).map((task) => {
      if (task.id === id) return value
      return task
    })
  }

  @action.bound
  updateAllTaskGroup = async (id, values = {}) => {
    try {
      this.taskGroupLoader = true
      let response = await this.post(undefined, {
        id,
        ...values,
      })
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.taskGroupLoader = false
    }
  }

  @action.bound
  deleteAllTaskLocally = (id) => {
    this.allTaskGroups = (this.allTaskGroups || []).filter((task) => {
      return task.id !== id
    })
  }

  @action.bound
  deleteAllTaskGroup = async (id, values = {}) => {
    try {
      this.taskGroupLoader = true
      let response = await this.post(undefined, {
        id,
        ...values,
      })
      if (response.status) {
        return [true, response.data]
      }
      return [false, response.data]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.taskGroupLoader = false
    }
  }
  /** Global task group ends here */

  @action.bound
  resetFilterForm = () => {
    this.dashboardAllTaskPageFilters = {}
    this.cfSelectedDateChoice = undefined
  }

  @action.bound
  resetStore = () => {
    this.genericTaskLoader = false
    this.taskGroupLoader = false
    this.taskLoader = undefined
    this.addTaskLoader = false
    this.specificTaskLoader = false
    this.editTaskLoader = false
    this.ordering = undefined
    this.orderingBy = undefined
    this.allDropdownTaskGroupsList = []
    this.allDropdownTaskGroupslistFromFolder = []
    this.allDropdownTaskAssignedRoles = []
    this.allDropdownTaskAssignedUsers = []
    this.bulkTaskUpdateLoader = false
    this.allTaskGroups = []
    this.taskGroups = []
    this.isUserAssignedInTaskGroups = false
    this.taskList = []
    this.taskListforDropdown = []
    this.cfSelectedDateChoice = undefined
    this.task = {}
    this.isUserAssignedInTask = false
    this.taskTemplates = []
    this.taskTemplatesForDropdown = []
    this.taskTypes = []
    this.taskSubTypes = []
    this.allTaskStatus = []
    this.openedTaskGroupIdGlobal = undefined
    this.assignTaskLoader = false
    this.changeTaskStatusLoader = false
    this.projectDashboardAllTasksLoader = false
    this.projectDashboardAllTasks = {}
    this.projectDashboardStatusId = API_CONSTANTS.PROJECT_DASHBOARD_IN_PROGRESS
    this.dropdownDashboardSpaceId = undefined
    this.dashboardAllTasksPageNo = DEFAULT_PAGE_START
    this.dashboardAllTasksPageSize = DEFAULT_PER_PAGE_RECORD
    this.dashboardAllTasksLoader = false
    this.dashboardAllTasksTotal = 0
    this.dashboardAllTasks = []
    this.dashboardAllTaskPageFilters = ''
    this.isCommingFromWieght = false
    this.spaceShortDetailsForTask = {}
    this.taskSearchText = undefined
    this.taskGroupForSpaceLoader = false
    this.importTasks = []
    this.importEquipments = []
    this.importTaskFailures = []
    this.importEquipmentsFailures = []
    this.importTasksLoader = false
    this.importEquipmentsLoader = false
  }
}
